export const isMobileSmall = (width = window.innerWidth) => width < 350;

export const isMobile = (width = window.innerWidth) => width < 450;

export const isTablet = (width = window.innerWidth) => width >= 650 && width <= 1023;

export const isTouch = (width = window.innerWidth) => width <= 1023;

export const isDesktop = (width = window.innerWidth) => width >= 1024; // && window.screen.width <= 1215;

export const isWideScreen = (width = window.innerWidth) => width >= 1216; // && window.screen.width <= 1407;

export const isFullHD = (width = window.innerWidth) => width >= 1408;

export const is1080p = (width = window.innerWidth) => width >= 1808

export const is2K = (width = window.innerWidth) => width >= 2560;